{
  "defaultEntitySelectLabel": "Name",
  "defaultRelationSelectLabel": "Relationship"
}
